import LatestPosts from './LatestPosts';

export default LatestPosts;
